import client from '@/plugins/axios.js'

export default  {
  getAllNotifications(){
      return new Promise((resolve,reject)=>{
          client({requiresAuth:true}).get('/api/notifications/')
            .then((res)=>{
              resolve(res.data.data)
            })
            .catch((err)=>{
              reject(err)
            })
        });
    },

    setNotificationsRead(id){
      return new Promise((resolve,reject)=>{
        client({requiresAuth:true}).post('/api/notification/' + id + '/markAsRead')
          .then((res)=>{
            resolve(res.data.data)
          })
          .catch((err)=>{
            reject(err)
          })
      });
    }
}
